/* * @Author: ligai  */ 
<template>
  <span class="currency-price_view-box">
    <template v-if="type === 'amount'">
      <span class="currency">{{currencySymbol}}</span><span v-if="hideValue" class="price">{{formatValue}}</span>
    </template>
    <template v-if="type === 'name'">
      <span>{{currencySymbol}}/{{currencyName}}</span>
    </template>
    <slot name="other"></slot>
    <slot name="currencyBase" :code="baseCurrencyCode"></slot>
  </span>
</template>
<script>
import { componentMessage } from '../../utils'
import { mixin } from '../common/mixins'
import Store from '../../../../common/catch-state/store'
import Model from '../common/field-precision-currency'
Store.install(Model)

export default {
  name: 'currency-text',
  mixins: [mixin],
  data () {
    return {
      baseCurrencyCode: '', // 本位币code
      currencyList: [] // 币种列表
    }
  },
  props: {
    // amount：￥300；  name：￥/人民币
    type: {
      type: String,
      default: 'amount'
    },
    // 隐藏金额
    hideValue: {
      type: Boolean,
      default: true
    },
    // 金额
    value: {
      type: [String, Number],
      default: ''
    },
    // 币种code
    currencyCode: {
      type: String,
      default: ''
    },
    // 取值币种法定精度
    currencyPrecision: {
      type: Boolean,
      default: false
    },
    // 自定义精度
    ratio: {
      type: [String, Number],
      default: null
    },
    // 是否保留小数后的0
    padding: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: true
    },
    // 是否启用系统单价小数点后几位
      // 1、ratio有值时：
        // 1)截取后的金额为0，实际为非0，精度取系统单价小数位，并不保留小数后的0【示例：ratio为2位小数显示，当金额太小，四舍五入后为“0.00”（非0），按系统单价显示规则展示；（如：0.0015、0.001）】
        // 2)截取后的金额为非0，精度取ratio
      // 2、ratio无值时：精度取系统单价小数位
    isAmountSystem: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLogin: {
      handler: async function (nVal, oVal) {
        if (nVal) {
          this.getSystemRules()
          if (this.isAmountSystem) {
            this.getMoneyDecimalsPoint()
          }
          const currencyListRes = await Store.currency('getCurrencyList').getter()
          const baseCurrencyRes = await Store.currency('getCurrencyBase').getter()
          if (!currencyListRes || !baseCurrencyRes) {
            return false
          }
          this.currencyList = currencyListRes.currencyList
          this.baseCurrencyCode = baseCurrencyRes.baseCurrencyCode
          this.$emit('getBaseCurrencyCode', this.baseCurrencyCode)
        }
      },
      immediate: true
    }
  },
  async created () {
    // 适用于供应商端 采购商端 商城端 供应商门户
    let flag = componentMessage(['supplier', 'purchaser', 'mall', 'supplier-home'], 'currency-text 多币种')
    if (flag) return
  },
  computed: {
    // 获取币种名称
    currencySymbol () {
      if (!this.currencyCode && this.baseCurrencyCode) {
        this.currencyCode = this.baseCurrencyCode
      }
      return this.getCurrencyFiled(this.currencyCode)
    },
    currencyName () {
      if (this.type === 'name') {
        return this.getCurrencyFiled(this.currencyCode, 'name')
      }
    },
    // 获取精度
    precision () {
      if (this.currencyPrecision) {
        return this.getCurrencyFiled(this.currencyCode, 'precision')
      } else {
        return this.ratio
      }
    },
    newVal () {
      let val = this.formatPrice(this.value, this.precision, this.padding)
      if (parseFloat(val) === 0 && parseFloat(this.value) !== 0 && this.isAmountSystem) {
        val = this.formatPrice(this.value, this.systemRules.priceDecimalsPoint)
      }
      return val
    },
    formatValue () {
      if (this.newVal === '' || this.newVal === 'undefined' || this.newVal === null) return '-'
      const value = this.newVal.toString()
      const { priceThousandthPercentileEnabled } = this.systemRules
      const result = value.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
        return s1.replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,') + s2
      })
      return priceThousandthPercentileEnabled ? result : value
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
  .currency-price_view-box {
    display: inline-block;
    line-height: 1;
  }
</style>